// The app is not a PWA any more. This only removes a worker an earlier install left
// behind; public/service-worker.js is the kill-switch that cleans its caches.
//
// getRegistrations() rather than serviceWorker.ready: `ready` only resolves once a worker
// is active, so a browser holding a waiting worker would never be cleaned.
export function unregisterAll() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => registrations.forEach((r) => r.unregister()))
    .catch((error) => console.error(error.message));
}
